import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Principal } from "@dfinity/agent";
import { toast } from "react-toastify";

import Button from "@origyn-sa/common-ui/src/components/atoms/Button";
import Table from "@origyn-sa/common-ui/src/components/organisms/Table";
import { ReactComponent as ArrowIcon } from "@origyn-sa/common-ui/src/assets/icons/arrow.svg";
import NFTItemContent from "./NFTItemContent";
import NFTSkeleton from "./NFTSkeleton";
import { fetchItemById, fetchTokenEvents } from "../../utils";
import {
  // client,
  // CustomCanisterClient,
  // marketplace_token_id,
  canistersFactoryMap,
  client,
  // CustomCanisterClient,
  getIdentity,
  ICPClient,
} from "../../agent";
import TransferModal from "./TransferItemModal";
//import ListItemModal from "@origyn-sa/common-ui/src/components/templates/ListItemModal";
import ApprovalItemModal from "./ApproveItemModal";
import { fetchPaymentMethods } from "../../utils";
import { displayPriceFromListing } from "../../utils";
import { mapEventList } from "@origyn-sa/common-ui/src/helpers/events";
import { transferNft } from "../../utils";
import { PaymentMethodType } from "../../types";
import BuyItemModal from "./BuyItemModal";
import ListItemModal from "./ListItemModal";

type IItemPageProps = {
  showApproval: boolean;
  showListing: boolean;
  showTransfer: boolean;
  loggedInUser: string | undefined; // Principal
};

const ItemPage = ({
  showApproval = false,
  showListing = false,
  showTransfer = false,
  loggedInUser,
}: IItemPageProps) => {
  const [administrator, setAdministrator] = useState<any>(null);
  const { itemId, canisterId: nftCanisterId } =
    useParams<{
      itemId: string;
      canisterId: string;
    }>();

  console.debug({ itemId, nftCanisterId });
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethodType[]>([]);
  const [owner, setOwner] = useState<string>("");
  const [transferModalOpened, setTransferModalOpened] =
    useState<boolean>(false);
  const [isListModalOpened, setIsListModalOpened] = useState<boolean>(false);
  const [isBuyModalOpened, setIsBuyModalOpened] = useState<boolean>(false);
  // const [isUnlistModalOpened, setIsUnlistModalOpened] = useState(false);
  const [isApprovalModalOpened, setApprovalModalOpen] =
    useState<boolean>(false);
  const [listing, setListing] = useState<any>();
  const [item, setItem] = useState<any>();
  const [NFTHistory, setNFTHistory] = useState<any>(); // FIXME: Type
  const history = useHistory();
  const [approval, setApproval] = useState<string>("");

  console.debug({ paymentMethods });

  useEffect(() => {
    if (!administrator) {
      const actor = client.getNewNftActor(nftCanisterId); //new CustomCanisterClient(nftCanisterId);
      console.log(actor, "APPPPIII", nftCanisterId);
      actor.admin().then((admin: any) => {
        setAdministrator(admin);
      });
    }
  }, [administrator]);

  useEffect(() => {
    if (showListing) {
      fetchPaymentMethods().then((data: PaymentMethodType[]) => {
        setPaymentMethods(data);
      });
    }
  }, [showListing, nftCanisterId, itemId]);

  const loadData = useCallback(() => {
    fetchItemById(nftCanisterId, itemId)
      .then((itemDetails) => {
        console.log(itemDetails);
        setItem(itemDetails);
      })
      .catch((err) => {
        console.error(err);
      });
    fetchTokenEvents(nftCanisterId, itemId)
      .then(mapEventList)
      .then(setNFTHistory)
      .catch((err) => {
        console.error(err);
      });

    if (item?.id) {
      const actor = client.getNewNftActor(nftCanisterId); //new CustomCanisterClient(nftCanisterId);
      actor.ownerOf(item?.id).then((o: any) => {
        console.debug({ item, o, approval });
        setOwner(o.toString());

        if (o) {
          console.debug("getApproval", o, item.id);
          const actor = client.getNewNftActor(nftCanisterId);
          actor
            .getApproval(
              o,
              Principal.fromText(ICPClient.getCanisterId()),
              item.id
            )
            .then((approval: string) => {
              console.debug({ approval });
              setApproval(approval);
            })
            .catch((err: any) => {
              console.error({ err });
              toast.error({ err });
            });
        }
      });
    }
    if (showListing && client.actor) {
      client.actor
        .getListingByCollectionAndTokenID(
          Principal.fromText(nftCanisterId),
          itemId
        )
        .then((l: any) => {
          console.log({ msg: "itemListed", l });
          setListing(l);
        })
        .catch((err: any) => {
          console.error(err);
          setListing(undefined);
        });
    }
  }, [nftCanisterId, itemId, showListing, item?.id]);

  useEffect(() => {
    const interval = setTimeout(() => loadData(), 5000);
    return () => clearInterval(interval);
  }, [loadData]);

  console.log("listing stuff", listing);
  const listingPaymentMethod =
    listing &&
    paymentMethods.find(
      (pm: PaymentMethodType) =>
        pm._principal === listing.paymentMethodPrincipal.toText()
    );

  console.debug({ listingPaymentMethod });

  const renderChildren = () => {
    console.debug({ owner, listing, loggedInUser });
    if (loggedInUser && !listing) {
      if (approval === loggedInUser) {
        return null;
        // <Button
        //   outlined
        //   spacing={2}
        //   onClick={() => setIsListModalOpened(true)}
        // >
        //   List
        // </Button>
      } else {
        return null;
        // <div>
        //   To list the item for sale; You must <b>approve</b> the spender{" "}
        //   <b>{ICPClient.getCanisterId()}</b> with value <b>{loggedInUser}</b>{" "}
        //   in the NFT canister
        // </div>
      }
    }
    return null;
  };

  return (
    <>
      <Button
        textBtn
        small
        onClick={() => {
          history.goBack();
        }}
      >
        <ArrowIcon style={{ transform: "rotate(90deg)" }} />
        All items
      </Button>
      {item ? (
        <>
          <NFTItemContent
            {...item}
            owner={owner}
            isOwner={owner.toString() === loggedInUser}
            listing={listing}
            price={
              listing &&
              listingPaymentMethod &&
              displayPriceFromListing(listing, listingPaymentMethod)
            }
            // onUnlist={() => {
            //   if (!item.id) throw Error("item.id empty");
            //   client.actor
            //     .removeListing(Principal.fromText(nftCanisterId), item.id)
            //     .then((e: any) => {
            //       toast.success(`Listing removed: ${e}`);
            //     })
            //     .catch((err: any) => {
            //       toast.error(`Failed to remove listing ${err}`);
            //     })
            //     .finally(() => loadData());
            // }}
            actionChildren={renderChildren()}
            showTransfer={false}
            showListing={showListing}
            onTransfer={() => {}}
            onBuy={() => setIsBuyModalOpened(true)}
            showApproval={false}
          />
          <ApprovalItemModal
            item={item}
            open={isApprovalModalOpened}
            onClose={() => setApprovalModalOpen(false)}
            onApprove={(vals: any) => {
              console.log("todo: onApprove", vals);
              // const api = new CustomCanisterClient(nftCanisterId);
              // api.agent
              //   .approve(Principal.fromText(vals.spender), vals.tokenId)
              //   .then(() => {
              //     toast("Approved");
              //   })
              //   .catch(toast.error)
              //   .finally(() => {
              //     setApprovalModalOpen(false);
              //   });
            }}
            onRemoveApproval={(vals: any) => {
              console.log("todo: onRemoveApproval", vals);
              // const api = client. //new CustomCanisterClient(nftCanisterId);
              // api.agent
              //   .removeApproval(
              //     Principal.fromText(vals.existingSpender),
              //     vals.tokenId
              //   )
              //   .then(() => {
              //     toast("Approval removed");
              //   })
              //   .catch(toast.error)
              //   .finally(() => {
              //     setApprovalModalOpen(false);
              //   });
            }}
            approvals={[]}
          />
          <BuyItemModal
            item={item}
            listing={listing}
            listingPaymentMethod={listing && listingPaymentMethod}
            onConfirm={() => {
              console.debug("TODO: onConfirm");
            }}
            onClose={() => {
              console.debug("TODO: onClose");
              setIsBuyModalOpened(false);
              window.location.reload();
            }}
            open={isBuyModalOpened}
          />
          <TransferModal
            open={transferModalOpened}
            onClose={() => {
              setTransferModalOpened(false);
              loadData();
            }}
            onTransfer={(vals: any) => {
              console.log("onTransfer", vals);
              transferNft(nftCanisterId, itemId, vals.recipient, vals.memo)
                .then(() => {
                  toast.success("Item sent");
                })
                .catch(toast.error)
                .finally(() => {
                  setTransferModalOpened(false);
                });
            }}
            item={item}
          />
        </>
      ) : (
        <NFTSkeleton />
      )}
      {NFTHistory && (
        <Table
          spacing={4}
          fullWidth
          tableHeadline='NFT history'
          values={[
            { label: "Event", colspan: "1" },
            { label: "Date", colspan: "1" },
          ]}
          data={
            NFTHistory && NFTHistory.length
              ? NFTHistory.map((data: any) => [
                  { label: data.eventKind },
                  {
                    label: `${data.time.toLocaleDateString()} at ${data.time.toLocaleTimeString()}`,
                  },
                ])
              : [[{ label: "No transfer yet.", colspan: "3" }]]
          }
        />
      )}
    </>
  );
};

export default ItemPage;
